import NewsBlock from './NewsBlock';

export default NewsBlock;
